import DataTable from "react-data-table-component"
import styles from './VIPCustomerInsights.module.scss'

const VIPCustomerInsigts = () => {

  const data = [
    { campaign: 'Summer Sale', engagementRate: '45%', reach: '12,000', impressions: '18,000', followerGrowth: 300 },
    { campaign: 'Summer Sale', engagementRate: '45%', reach: '12,000', impressions: '18,000', followerGrowth: 300 },
    { campaign: 'Summer Sale', engagementRate: '45%', reach: '12,000', impressions: '18,000', followerGrowth: 300 },
  ]

  const columns = [
    {
      name: 'Post/Campaign',
      selector: row => row.campaign
    },
    {
      name: 'Engagement Rate',
      selector: row => row.engagementRate
    },
    {
      name: 'Reach',
      selector: row => row.reach
    },
    {
      name: 'Impressions',
      selector: row => row.impressions
    },
    {
      name: 'Follower Growth',
      selector: row => row.followerGrowth
    },
  ]

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <>
      <div className="fw-medium fs-5 my-3">Social Media Performance:</div>

      <div className="bg-white p-2">
        <div className={styles['wrapper']}>
          <div className="mb-3">Following are the policies that you have violated, along with the date, status , and actions required or taken.</div>

          <DataTable columns={columns} data={data} customStyles={customStyles} />
        </div>

      </div>
    </>
  )
}

export default VIPCustomerInsigts